export default __webpack_public_path__ + "static/media/successful_payment.4b2a0a23.png";